import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// CasingSize — shown when TransomCasing is a wood material (MDF, FJPine, Poplar, RedOak)
const OPTIONS = [
  { value: '2 3/4"', label: '2 3/4"' },
  { value: '3 1/2"', label: '3 1/2"' },
];

const CasingSize = ({ value = { value: '', label: '' }, onChange, disabled = false }) => {
  const [selected, setSelected] = useState(value?.value || '');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdCasingSize">Casing Size</label>
      <select id="SdCasingSize" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CasingSize;
